/**
 * Judge.me's eigenes Core-Widget rendert role="tab"-Buttons (Bewertungen/
 * Fragen bzw. Produkt-/Shop-Bewertungen) mit aria-controls, das auf eine
 * ID zeigt, die im DOM nie erzeugt wird (z. B. "jdgm-tabpanel_product_
 * reviews" existiert nicht) — live auf PDP und /pages/reviews bestaetigt,
 * kein Config-Fehler unsererseits, das Markup kommt komplett aus Judge.mes
 * eigenem Script. Ein toter aria-controls-Verweis ist fuer Screenreader/
 * KI-Agenten schlechter als gar keiner, daher hier entfernt statt versucht,
 * ein Panel nachzubauen, das mit einem App-Update sofort wieder abweichen
 * koennte.
 */
(() => {
  const fixTab = (el) => {
    const controls = el.getAttribute('aria-controls');
    if (controls && !document.getElementById(controls)) {
      el.removeAttribute('aria-controls');
    }
  };

  const scan = (root) => {
    root.querySelectorAll('[role="tab"][aria-controls]').forEach(fixTab);
  };

  scan(document);

  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType !== 1) return;
        if (node.matches?.('[role="tab"][aria-controls]')) fixTab(node);
        node.querySelectorAll?.('[role="tab"][aria-controls]').forEach(fixTab);
      });
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
})();
